// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"e59ebd7b","916":"10422924"}[chunkId] + ".chunk.css";
};